module.exports = __webpack_public_path__ + "img/b_s_4.5ff01dd7.png";